export default __webpack_public_path__ + "static/media/Wrist-straps of the Death Master (nm).162c91a3.jpg";